// assets/pubsub.js
// This file is kept for compatibility but defers to the initialization in pubsub-init.js

(function() {
  'use strict';
  
  // Check if PubSub is already initialized
  if (window.PubSub && window.PubSub.subscribe && window.PubSub.publish) {
    console.log('[pubsub.js] PubSub already initialized, using existing instance');
    return;
  }
  
  // If not initialized, something went wrong with pubsub-init.js
  console.warn('[pubsub.js] PubSub was not initialized by pubsub-init.js, initializing now');
  
  // Initialize subscribers storage
  window.subscribers = window.subscribers || {};

  function subscribe(eventName, callback) {
    if (window.subscribers[eventName] === undefined) {
      window.subscribers[eventName] = [];
    }

    window.subscribers[eventName] = [...window.subscribers[eventName], callback];

    return function unsubscribe() {
      window.subscribers[eventName] = window.subscribers[eventName].filter((cb) => {
        return cb !== callback;
      });
    };
  }

  function publish(eventName, data) {
    if (window.subscribers[eventName]) {
      const promises = window.subscribers[eventName]
        .map((callback) => callback(data));
      return Promise.all(promises);
    } else {
      return Promise.resolve();
    }
  }

  // Set up global access
  window.subscribe = window.subscribe || subscribe;
  window.publish = window.publish || publish;
  
  if (!window.PubSub) {
    window.PubSub = { subscribe, publish };
  }
})();